<template>
  <iframe
    :src="iframe_src"
    frameborder="0"
    width="100%"
    height="800"
  />
</template>
<script>
import { showToast } from '@/@core/utils/utils'
import { io } from 'socket.io-client';
import { getToken, getUser } from '@/auth/utils';

export default {
  components: {
  },
  props: {
    fileData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      iframe_src: `http://localhost:5056/?access_token=${getToken()}`,
      fileDataTest: {
        id: 779,
        category_id: 1389,
        uuid: '',
        queue_id: 0,
        asset_id: null,
        version_id: null,
        name: 'Xung dot Nga - Ucraina',
        description: '',
        type: 'audio',
        file_path: '',
        file: 'xung_dot_nga_ucraina_20230721112356.mp3',
        file_original: '',
        file_proxy: '',
        extension: 'mp3',
        mimetype: 'audio/x-m4a',
        filesize: 1465746,
        created_by: 'root',
        created_at: '2023-07-21 11:23:57',
        updated_by: 1,
        updated_at: '2023-07-21 11:23:57',
        deleted_at: 0,
        deleted_by: 0,
        published_at: '1970-01-01 08:00:00',
        published_by: 0,
        status: 0,
        file_local: 'https://media.tintucvov.vn/upload/xung_dot_nga_ucraina_20230721112356.mp3',
        mam_status: 0,
        log_message: null,
        keyword: 'Xung dot Nga  Ucraina',
        duration: '0',
        path: null,
        dalet_status: 0,
        sync_dalet: 1,
        username: 'root',
        progress: 100,
        transcribe: 4,
        transcribe_text: null,
        thumbnail: 0,
        status_text: 'L\u1ed7i',
        mam_status_text: 'L\u1ed7i',
        itemType: 'file',
      },
    }
  },
  computed: {

  },
  watch: {

  },
  mounted() {
    // console.log('this.fileData', this.fileData);
    const audioUrl = process.env.VUE_APP_AUDIO_URL || 'http://localhost:5056/';
    const fileName = `${this.fileData.name}.${this.fileData.extension}`;
    this.iframe_src = `${audioUrl}?access_token=${getToken()}&file=${this.fileData.file_local}&id=${this.fileData.id}&name=${fileName}`;
    // console.log('this.iframe_src', this.iframe_src);

    this.initCommunicateIframe()
  },
  unmounted() {
    // console.log('unmounted');
    this.socket.disconnect()
    window.removeEventListener('message', this.listenFromAudioIframe);
    // console.log('on unmout');
  },
  methods: {
    storeLog(data) {
      const userData = getUser();
      const storeData = {
        user_id: userData.id,
        name: `Biên tập audio: ${data.filename_original}`,
        note: `Audio đã chỉnh sửa: ${data.filename}`,
        action: 'add',
        json_data: data,
      };
      console.log('storeData', storeData);
      this.$store.dispatch('logs/storeAudioEditingLog', storeData);
    },
    listenFromAudioIframe(e) {
      // console.log('listenFromAudioIframe', e);
      try {
        const data = JSON.parse(e.data);
        console.log('data', data);
        // Where does the message come from
        const { channel, message } = data;
        if (channel === 'vovat_audio_service') {
          showToast(message, { variant: 'success' })
          this.storeLog(data);
          this.closeModal();
        }
      } catch (error) {
        console.log('listenFromAudioIframe error: ', error.message);
      }
    },
    initCommunicateIframe() {
      window.addEventListener('message', this.listenFromAudioIframe);
    },
    initSocket() {
      const socketUrl = process.env.VUE_APP_SOCKET_IO || 'http://localhost:3000/';
      const socketPath = process.env.VUE_APP_NOTY_SOCKET_PATH || '/socket.io/';
      const socket = io(socketUrl, {
        path: socketPath,
        transports: ['websocket'],
      });
      console.log('audio initSocket', socketUrl, socketPath);
      this.socketSpeech = socket;

      socket.on('connect', () => {
        console.log('socket audio on connect');
        this.socketId = socket.id;
      });
      socket.on('noty-audio-editor', (data) => {
        console.log('socket on noty-audio-editor', data);
        showToast('noty-audio-editor', { variant: 'success' });
        this.closeModal();
        // console.log('data.file_id, this.fileData.id', data.id, that.fileData.id);
        // const jsonPretty = JSON.stringify(data, null, 2);
        // const payload = {
        //   fileName: data.fileName,
        //   fileData: data.fileData,
        //   provider: data.provider,
        // }

        // if (data.type === 'transcribe_completed') {
        //   if (data.audio_id) {
        //     // that.$emit('update-transcribe-status', { id: that.fileData.file_id, transcribe: data.status });
        //     console.log('<p>socket speech on transcribe_completed</p>');
        //     that.generateTextPart(data.text_parts)
        //   }
        // }
        // console.log(`<p>${jsonPretty}</p>`);
      });

      socket.on('disconnect', () => {
        console.log('socket audio on disconnect');
      });

      this.socket = socket
    },
    openModal() {
      this.$bvModal.show('modalAudio')
    },
    closeModal() {
      this.$bvModal.hide('modalAudio')
      this.socket.disconnect()
      window.removeEventListener('message', this.listenFromAudioIframe);
    },
  },
}
</script>
<style lang="scss"></style>
